import BaseEvent from "../../util/baseEvent"
import axios from "axios"
import Erizo from "../../lib/vnErizo/Erizo"
import ChooseEc from "./chooseIdc"
import { apiURL } from "@/config"
// import Base64 from "../../util/Base64"
let haspublishCall = false
class MbsCoreSdk extends BaseEvent {
  constructor() {
    super()
    this.$logger.setPrefix("vn")
    this.clientId = null
  }
  enterRoom(authInfo) {
    this.client = null
    this.localStream = null
    let self = this
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: apiURL + "/api/vps/service/openclass/gslb/ec/createtoken",
        data: Object.assign({}, authInfo)
      })
        .then(res => {
          let { data } = res.data
          let ec = new ChooseEc(data.token)
          this.eventEmitter.once("GET_EC_SUCCESS", bestEcIndex => {
            console.log("=============GET_EC_SUCCESS=========", bestEcIndex)
            this.client = Erizo.Room({ token: data.token[bestEcIndex] })
            this.clientId = authInfo.userId
            this.client.connect({
              singlePC: false,
              url: data.ali.rtmpAddr,
              roomId: authInfo.roomId,
              userId: authInfo.userId,
              videoWidth: 640,
              videoHeight: 480,
              videoFrameRate: 15,
              agora: { ...data.agora },
              tencent: { ...data.ten }
            })
            self.initEvent()
            this.client.addEventListener("room-connected", function(roomEvent) {
              resolve({ status: 1, roomEvent })
            })
            this.client.addEventListener("room-error", function(err) {
              reject(new Error("enterMediaRoom:" + err))
            })
          })
          this.eventEmitter.on("GET_EC_FAILED", err => {
            reject(new Error("enterMediaRoom:" + err))
          })
        })
        .catch(err => {
          reject(new Error("enterMediaRoom:" + err))
        })
    })
  }
  exitRoom() {
    return new Promise((resolve, reject) => {
      haspublishCall = false
      this.client && this.client.disconnect()
      this.destroy()
      this.client.addEventListener("room-disconnected", function() {
        resolve({ status: 0 })
      })
    })
  }
  getDeviceList() {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .enumerateDevices()
        .then(mediaDeviceInfo => {
          resolve(mediaDeviceInfo)
        })
        .catch(err => {
          reject(new Error(err))
        })
    })
  }
  getMedialStream(config) {
    let self = this
    return new Promise((resolve, reject) => {
      this.localStream = Erizo.Stream({
        video: config.video,
        audio: config.audio,
        data: config.data || true,
        screen: config.screen || false,
        videoSize: config.videoSize || [640, 480, 640, 480],
        videoFrameRate: config.videoFrameRate || [15, 15],
        cameraId: config.cameraId || undefined,
        microphoneId: config.microphoneId || undefined
      })
      this.localStream.init()
      this.localStream.addEventListener("access-accepted", function(event) {
        resolve(self.localStream)
      })
      this.localStream.addEventListener("access-denied", function(event) {
        reject(new Error('Access to webcam and/or microphone rejected"'))
      })
    })
  }
  getShowMedialStream(config) {
    let self = this
    return new Promise((resolve, reject) => {
      let showStream = Erizo.Stream({
        video: config.video,
        audio: config.audio,
        data: config.data || true,
        screen: config.screen || false,
        videoSize: config.videoSize || [640, 480, 640, 480],
        videoFrameRate: config.videoFrameRate || [15, 15],
        cameraId: config.cameraId || undefined,
        microphoneId: config.microphoneId || undefined
      })
      showStream.init()
      showStream.addEventListener("access-accepted", function(event) {
        resolve(showStream)
      })
      showStream.addEventListener("access-denied", function(event) {
        reject(new Error('Access to webcam and/or microphone rejected"'))
      })
    })
  }
  publishMedialStream(stream, options) {
    return new Promise((resolve, reject) => {
      this.client.publish(stream || this.localStream, options, function(
        id,
        err
      ) {
        if (!id) {
          reject(new Error("发布失败" + err))
        }
      })
      if (haspublishCall) {
        resolve(stream || this.localStream)
        return
      }
      this.client.on("stream-added", evt => {
        haspublishCall = true
        let stream = evt.stream
        this.emit("STREAM_PUBLISHED", evt)
        resolve(stream || this.localStream)
      })
    })
  }
  unpublishMedialStream(stream) {
    let self = this
    let localId = JSON.stringify(self.localStream.getID())
    return new Promise((resolve, reject) => {
      self.client.unpublish(stream || this.localStream, function(id, err) {
        if (err) {
          reject(new Error("取消发布失败" + err))
        }
      })

      self.client.off("stream-removed", function(evt) {
        self.onRemove(evt, localId, data => {
          resolve(data)
        })
      })
      self.client.on("stream-removed", function(evt) {
        self.onRemove(evt, localId, data => {
          resolve(data)
        })
      })
    })
  }
  onRemove(evt, localId, callback) {
    let self = this
    console.log("localId", localId)
    // let localId = JSON.stringify(self.localStream.getID())
    // console.log("evt.stream.getID()", self.localStream.getID())
    if (localId && JSON.stringify(evt.stream.getID()) === localId) {
      self.emit("STREAM_UNPUBLISHED", self.localStream)
      callback(true)
    }
  }
  playMedial(config) {
    let stream = config.stream || this.localStream
    return new Promise((resolve, reject) => {
      if (stream) {
        stream.play(config.videoId)
        resolve(stream)
      } else {
        reject(new Error("play failed,you should getMediaStream first!"))
      }
    })
  }
  // playShowMedia(config,stream){
  //   return new Promise((resolve, reject) => {
  //     if (stream) {
  //       stream.play(config.videoId)
  //       resolve(stream)
  //     } else {
  //       reject(new Error("play failed"))
  //     }
  //   })
  // }
  closeMedial(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.stop()
      resolve("关闭本地媒体成功")
    })
  }
  enableVideo(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.muteVideo(false, function(result) {
        console.log("result", result)
      })
      resolve(streamObj)
    })
  }
  disableVideo(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.muteVideo(true, function(result) {
        if (result === "error") {
          reject(new Error(result))
        }
      })
      resolve(streamObj)
    })
  }
  enableAudio(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.muteAudio(false, function(result) {
        reject(new Error(result))
      })
      resolve(streamObj)
    })
  }
  disableAudio(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.muteAudio(true, function(result) {
        reject(new Error(result))
      })
      resolve(streamObj)
    })
  }
  subscribeMedialStream(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      this.client.subscribe(streamObj, function(err) {
        reject(new Error(err + "订阅失败"))
      })
    })
  }
  getLocalStream() {
    return this.localStream
  }
  initEvent() {
    let self = this
    // let streamId = null
    // let localId = null
    // 订阅音视频
    // this.client.on("stream-added", function(evt) {
    //   let stream = evt.stream
    //   streamId = evt.stream.getID()
    //   localId = self.localStream.getID()
    //   if (streamId === localId) {
    //     // 老师发布流成功
    //     self.emit("STREAM_PUBLISHED", evt)
    //   } else {
    //     self.subscribeMedialStream(stream)
    //   }
    // })

    // A stream has failed, either in the connection establishment or during the communication.
    this.client.on("stream-failed", function(evt) {
      self.localStream = evt.stream
      self.emit("STREAM_FAILED", evt)
    })
    // 监听订阅
    this.client.on("stream-subscribed", function(evt) {
      self.localStream = evt.stream
      self.emit("STREAM_PUBLISHED", evt)
    })
    // 打开视频
    this.client.on("unmute-video", function(evt) {
      self.emit("VIDEO_OPEN", evt)
    })
    // 关闭视频
    this.client.on("mute-video", function(evt) {
      self.emit("VIDEO_CLOSE", evt)
    })
    // 打开音频
    this.client.on("unmute-audio", function(evt) {
      self.emit("AUDIO_OPEN", evt)
    })
    // 关闭音频
    this.client.on("mute-audio", function(evt) {
      self.emit("AUDIO_CLOSE", evt)
    })
    // 取消订阅音视频
    // this.client.on("stream-removed", function(evt) {
    //   console.log('==============evt.stream.getID()=======================',evt.stream.getID())
    //   if (streamId && evt.stream.getID() === streamId) {
    //     self.emit("STREAM_UNPUBLISHED", evt)
    //   } else {
    //     self.emit("STREAM_UNPUBLISHED", evt)
    //   }
    // })

    // 监听房间ws断开连接
    this.client.addEventListener("room-disconnected", function(err) {
      console.log("===========room-disconnected==============", err)
      self.emit("ROOM_DISCONNECTED", err)
    })
  }
  destroy() {
    this.client.removeAllListeners()
  }
}
export default MbsCoreSdk
